import WhatAreYouAfraidOfSSO from "./WhatAreYouAfraidOfSSO";
export default WhatAreYouAfraidOfSSO;
